import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import type { ImportedAccountProvider } from "./importedAccountProvider";

interface Props {
    provider: ImportedAccountProvider;
}

export const ImportedAccountProviderHeader: React.FC<Props> = ({
    provider,
}) => (
    <>
        {provider.institution && (
            <InstitutionIcon institution={provider.institution} size="xs" />
        )}
        {provider.label}
    </>
);
